/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  position: relative;
  width: inherit;
  height: auto;
  .fill-1 {
    fill: #fff;
  }
  .fill-2 {
    fill: #f05f61;
  }
  .fill-3 {
    fill: #000;
  }
  .none {
    fill: none;
  }
`
export default class BaseballIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90" css={Color}>
        <g id="그룹_7158" data-name="그룹 7158" transform="translate(-445.5 -575.667)">
          <path id="패스_6446" className="fill-1" data-name="패스 6446" d="M490.5,580.667a40,40,0,1,1-40,40A40,40,0,0,1,490.5,580.667Z" fill="#fff"/>
          <rect id="사각형_5722" className="fill-2" data-name="사각형 5722" width="11.438" height="3.5" rx="1" transform="translate(467.999 618.918)" fill="#f05f61"/>
          <rect id="사각형_5723" className="fill-2" data-name="사각형 5723" width="11.439" height="3.5" rx="1" transform="matrix(0.966, -0.259, 0.259, 0.966, 467, 609.288)" fill="#f05f61"/>
          <rect id="사각형_5724" className="fill-2" data-name="사각형 5724" width="11.438" height="3.5" rx="1" transform="translate(462.172 599.387) rotate(-30)" fill="#f05f61"/>
          <rect id="사각형_5725" className="fill-2" data-name="사각형 5725" width="3.5" height="11.439" rx="1" transform="translate(466.999 632.048) rotate(-74.991)" fill="#f05f61"/>
          <rect id="사각형_5726" className="fill-2" data-name="사각형 5726" width="3.5" height="11.438" rx="1" transform="translate(462.171 641.948) rotate(-60)" fill="#f05f61"/>
          <path id="패스_6712" className="fill-2" data-name="패스 6712" d="M518.791,648.944a42.5,42.5,0,0,1-.011-56.566c-.589-.588-1.2-1.152-1.827-1.7a45,45,0,0,0-.008,59.991C517.576,650.109,518.2,649.54,518.791,648.944Z" fill="#f05f61"/>
          <path id="패스_6713" className="fill-2" data-name="패스 6713" d="M461.489,648.944a42.5,42.5,0,0,0,.01-56.566c.589-.588,1.2-1.152,1.827-1.7a45,45,0,0,1,.009,59.991C462.7,650.109,462.084,649.54,461.489,648.944Z" fill="#f05f61"/>
          <rect id="사각형_5722-2" className="fill-2" data-name="사각형 5722-2" width="11.438" height="3.5" rx="1" transform="translate(502.17 618.918)" fill="#f05f61"/>
          <rect id="사각형_5723-2" className="fill-2" data-name="사각형 5723-2" width="3.5" height="11.439" rx="1" transform="translate(502.653 609.706) rotate(-74.991)" fill="#f05f61"/>
          <rect id="사각형_5724-2" className="fill-2" data-name="사각형 5724-2" width="3.5" height="11.438" rx="1" transform="translate(507.78 596.699) rotate(-60)" fill="#f05f61"/>
          <rect id="사각형_5725-2" className="fill-2" data-name="사각형 5725-2" width="11.439" height="3.5" rx="1" transform="matrix(0.966, -0.259, 0.259, 0.966, 502.652, 631.629)" fill="#f05f61"/>
          <rect id="사각형_5726-2" className="fill-2" data-name="사각형 5726-2" width="11.438" height="3.5" rx="1" transform="translate(507.782 644.636) rotate(-30)" fill="#f05f61"/>
          <path id="패스_6709" className="none" data-name="패스 6709" d="M490.5,575.667h0a45,45,0,0,1,45,45h0a45,45,0,0,1-45,45h0a45,45,0,0,1-45-45h0a45,45,0,0,1,45-45Z" fill="none"/>
          <path id="패스_6710" className="none" data-name="패스 6710" d="M490.5,575.667h0a45,45,0,0,1,45,45h0a45,45,0,0,1-45,45h0a45,45,0,0,1-45-45h0a45,45,0,0,1,45-45Z" fill="none"/>
          <path id="패스_6711" className="fill-3" data-name="패스 6711" d="M490.5,665.667a45,45,0,1,1,45-45h0A45.051,45.051,0,0,1,490.5,665.667Zm0-85a40,40,0,1,0,40,40A40,40,0,0,0,490.5,580.667Z"/>
        </g>
      </svg>

    )
  }
}
